import * as types from "./actionTypes";
import { cloneDeep } from "../../utils/utils";
import { initialState } from "./initialState";

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case types.API_V1_GET_CLIENTS_SUCCESS:
      return setClient(state, action.payload);
    case types.API_V1_GET_CLIENTS_FAILURE:
      return initialState;
    default:
      return state;
  }
};

const setClient = (state, { id, name, accountLabel, accountsMap }) => {
  const clonedState = cloneDeep(state);

  clonedState.id = id;
  clonedState.name = name;
  clonedState.accountLabel = accountLabel;
  clonedState.accountsMap = accountsMap;

  return clonedState;
};

export default reducer;
